import React, { Fragment } from 'react';

import { nowUtil, subtractFromDateWithFormat } from '../../../utils/dates/date.utils';
import { YYYY } from '../../../utils/dates/dateFormats.utils';

import RenderConsumerSignUpNotEnabled from './fragments/renderConsumerSignupNotEnabled';
import RenderConsumerSignUpEnabled from './fragments/renderConsumerSignUpEnabled';

const Home = (props) => {

    const  {
        environment: {
            exchangeName,
            isState,
            consumerSignupEnabled,
            landingPageAnonymousTileShow
        },
        path
    } = props;


    const currentYear = nowUtil(YYYY);
    const previousYear = subtractFromDateWithFormat(1, 'year', YYYY);


    return (
        <Fragment>
            {
                consumerSignupEnabled ?
                    <RenderConsumerSignUpEnabled { ...{ exchangeName, isState, path, currentYear, landingPageAnonymousTileShow } }/>
                    : <RenderConsumerSignUpNotEnabled { ...{ currentYear, previousYear } }/>
            }
        </Fragment>
    );
};

export default Home;